<template>
  <div class="Container">
    <h2 class="ViewHeading">Clarence System Support Requests</h2>
    <div v-if="profileportal === 'CEU'">
      <SupportCEU />
    </div>
    <div v-if="profileportal === 'WMC' || profileportal === 'Admin'">
      <SupportWMC />
    </div>
    <div v-if="profileportal === 'SUP' || profileportal === 'Admin'">
      <SupportSUP />
    </div>
  </div>
</template>

<script>
import SupportWMC from "@/components/SupportWMC"; // @ is an alias to /src
import SupportCEU from "@/components/SupportCEU";
import SupportSUP from "@/components/SupportSUP";

export default {
  name: "SupportRequestsClarence",
  components: {
    SupportWMC,
    SupportCEU,
    SupportSUP,
  },

  created() {
    this.$auth.renewTokens().catch((err) => {
      err.message;
    });
  },
  data() {
    return {
      profileportal: "WMC",
      Auth0loggedIn: false,
      profile: {},
      themepref: this.$ThemePref,
      accessGroup: null,
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
    },
  },
};
</script>

<style></style>
